<div class="card-container h-100" style="border: 1px solid #e2e8f0; border-radius: 0.5rem; overflow: hidden; background: #ffffff;">
  <div class="card-header py-2 px-3 text-white font-weight-bold" style="background: var(--theme-primary, #123c53); font-size: 0.8125rem; text-transform: uppercase; letter-spacing: 0.5px;">
    <i class="fas fa-money-check mr-1"></i> Post Dated Cheque (PDC) Details
  </div>

  <div class="p-3" *ngIf="!PDCDetail || PDCDetail.length === 0">
    <div class="text-center p-3 bg-light rounded text-muted font-size-12">
      <i class="fas fa-info-circle mr-1"></i> No PDC Information Available!
    </div>
  </div>

  <div class="cnt-data p-3" *ngIf="PDCDetail && PDCDetail.length > 0">
    <div class="cont" style="display: flex; flex-direction: column; gap: 0.5rem;">
      <div *ngFor="let item of PDCDetail">
        <div class="p-2.5 rounded border" style="background: #fafbfc; border-color: #e2e8f0 !important;">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <span class="badge badge-primary px-2 py-1" style="background: var(--theme-primary, #123c53);">Type: {{ item.PdcType }}</span>
            <span class="font-weight-bold text-dark" style="font-size: 0.8125rem;">A/C: {{ item.Ac }}</span>
          </div>

          <div class="row m-0">
            <div class="col-6 p-1">
              <div class="small text-muted font-weight-bold">Bank Name</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item.Bankname || '-' }}</div>
            </div>
            <div class="col-6 p-1">
              <div class="small text-muted font-weight-bold">IFSC Code</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item.IFSCCode || '-' }}</div>
            </div>
          </div>

          <div class="row m-0 mt-1">
            <div class="col-6 p-1">
              <div class="small text-muted font-weight-bold">Branch</div>
              <div class="font-weight-bold text-dark" style="font-size: 0.8125rem;">{{ item.Branch || '-' }}</div>
            </div>
            <div class="col-6 p-1">
              <div class="small text-muted font-weight-bold">Cheque No</div>
              <div class="font-weight-bold text-primary" style="font-size: 0.8125rem;">{{ item.ChequeNo || '-' }}</div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>